export const AMAZON_SET_MARKET_PLACES= 'AMAZON_SET_MARKET_PLACES'
export const AMAZON_SET_SEARCH_CATEGORIES = 'AMAZON_SET_SEARCH_CATEGORIES'

export const AMAZON_SET_BRANDS = 'AMAZON_SET_BRANDS'
